<template>
    <VListItemAction v-bind="$attrs" :class="classList" v-on="$listeners">
        <slot />
    </VListItemAction>
</template>

<script>
import { USER_INPUT_CLASS } from '../../utils/classNames';

const ELEMENT_CLASS = 'sr-list-item-action';

export default {
    name: 'SrListItemAction',
    computed: {
        classList() {
            return [ELEMENT_CLASS, USER_INPUT_CLASS];
        },
    },
};
</script>
